import _ from 'lodash-es'
import store from '@/src/store'

// all possible comparison operators
export const compareOperators = [
    '=',
    '>',
    '<',
    '>=',
    '<=',
    '!=',
    'IN',
    'NOT IN',
    'LIKE',
    'NOT LIKE',
    'IN LIKE',
    'NOT IN LIKE',
    'IS NULL',
    'IS NOT NULL'
]

/**
 * Creates an array of options for the compare operator dropdown
 * @param compareType
 * @param isNumeric
 * @returns array
 */
export const getOperatorOptions = (compareType, isNumeric) => {
    return compareOperators.filter(item => {
        // "like" operator cannot be used on numeric values
        if (isNumeric && item.includes('LIKE')) {
            return false
        }
        // dynamic compare cannot be done with "in" and "like" operators
        if (compareType !== 'static' && (item.includes('IN') || item.includes('LIKE') || item.includes('NULL'))) {
            return false
        }
        return true
    })
}

/**
 * return a parsed compare value as string, along with the string value of the operator
 * @param compareValue
 * @param operator
 * @param isNumeric
 * @returns {{compareValue: string, operator: (*|null)}}
 */
export function computeCompareValueOperatorString(compareValue, operator, isNumeric) {
    const inSymbol = operator.includes('IN')
    if (inSymbol) {
        if (!isNumeric) {
            //we have a list of text elements so we show each of the element with quotes
            compareValue = compareValue.split(',').map(v => `'${v.trim()}'`).join(',');
        }
        //that wrap the elements in brackets
        compareValue = `(${compareValue})`;
    } else if (operator.includes('NULL')) {
        compareValue = ''
    } else if (!isNumeric) {
        //we are in a case where the operator is any other type so the compare value is a simple value
        //and if it is a text value we wrap it in quotes
        compareValue = `'${compareValue}'`;
    }

    return {
        compareValue,
        operator
    }
}

/**
 * clean compare value from quotes
 * @param val
 * @returns {string}
 */
function getStringVal(val) {
    //check if starts with single quote
    if (val.startsWith("'")) {
        //and in that case remove the first and the last element of the string
        //so to have the same string without quotes
        val = val.substr(1, val.length - 2);
    }
    return val;
}

/**
 * get the minimal string from compare value to be parsed, returns the value of the operator from its text and identify
 * if the value is numeric or not
 * @param compareValue
 * @param operator
 * @returns {{compareValue: string, isNumeric: boolean, operator: (*|null)}}
 */
export function inverseComputeCompareValueOperatorString(compareValue, operator) {
    let isNumeric;
    let parsedVal;
    //if this symbol is in the operator it means that we have a syntax like "IN ('a','b')"
    if (operator.includes('IN')) {
        //remove parenthesis, i.e. keep from second the second-last of "right" string, then split the values
        let values = compareValue.substr(1, compareValue.length-2).split(',').map(s => s.trim());
        //in the string we may have single quotes to indicates that they are string values.
        let parsedValues = values.map(getStringVal);
        //if the parsed value is identical to value it means that it did not contain quotes, so is numeric
        isNumeric = values[0] === parsedValues[0];
        //than the actual value that will be stored is a comma separated string with no quotes
        parsedVal = parsedValues.join(',');
    } else {
        //again we check and remove quotes
        parsedVal = getStringVal(compareValue);
        isNumeric = compareValue === parsedVal;
    }
    return {
        compareValue: parsedVal,
        operator,
        isNumeric
    }
}

//function to get all the table names that can be set as a property
export function getTableOptions(activityName) {
    // const activityTable = store.getters["repoStore/getActivityTable"](activityName)
    //tables to exclude
    // const activityTables = _.chain(store.getters["repoStore/getActivityTables"])
    //     .map(obj => obj.table).uniq()
    //     .filter(table => table != activityTable).value()
    //return all datamodel tables, except the activity tables.
    //The only exception is the current activity table which can be selected
    return store.getters["repoStore/getTables"]
    //     .filter(tableObj => {
    //     return !activityTables.includes(tableObj.name)
    // })
        .map(table => table.name).sort()
}

export const durationUnits = [
    {text: 'Years', value: 'y'},
    {text: 'Months', value: 'M'},
    {text: 'Weeks', value: 'w'},
    {text: 'Days', value: 'd'},
    {text: 'Hours', value: 'h'},
    {text: 'Minutes', value: 'm'},
    {text: 'Seconds', value: 's'},
]

export function durationUnitToText(unitCode) {
    const found = _.find(durationUnits, v => v.value === unitCode)
    return found ? found.text : ''
}